import React from "react";
import { Box, IconButton } from "@mui/material";
import {
  // ArrowBackIos,
  ArrowForwardIos,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import useInfoContext from "hooks/useInfoContext";
import "./index.scss";
import EditAccount from "assets/images/editAccount.png";
import SaveChanges from "assets/images/saveChanges.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@emotion/react";

const MainContent = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isSmallDevice = useMediaQuery(theme.breakpoints.down("md"));
  const {
    prePage,
    currentPage,
    // nextPage,
    editUserInfo,
    setEditUserInfo,
    setSaveChangesModal,
    setShowSidebar,
  } = useInfoContext();

  const handleBack = () => {
    if (prePage) {
      navigate(prePage.path);
    } else if (isSmallDevice) {
      navigate("/");
      setShowSidebar(true);
    } else if (!isSmallDevice) {
      navigate("/edit-account");
      setShowSidebar(true);
    }
  };

  // const handleNext = () => {
  //   navigate(nextPage.path)
  // };

  const saveChanges = () => {
    if (editUserInfo.edit === false) {
      setEditUserInfo({ edit: true });
    }
    if (editUserInfo.edit) {
      setSaveChangesModal(true);
    }
  };

  return (
    <Box
      className={`${
        isSmallDevice
          ? "main-content-component-wrapper delete-padding"
          : "main-content-component-wrapper"
      }`}
    >
      <Box className="main-content-box">
        <Box className="main-top-bar">
          {location.pathname === "/edit-account" ? (
            <IconButton onClick={saveChanges}>
              <img
                src={`${editUserInfo.edit ? SaveChanges : EditAccount}`}
                alt=""
                className={`${editUserInfo.edit ? "save-icon" : "edit-icon"}`}
              />
            </IconButton>
          ) : (
            <IconButton sx={{ visibility: "hidden" }}>
              <ArrowForwardIos />
            </IconButton>
          )}
          <Box className="page-title">
            {currentPage ? currentPage.name : null}
          </Box>
          <IconButton
            onClick={handleBack}
            disabled={!currentPage}
            color="secondary"
            className={!currentPage ? "hide" : null}
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
        <Box className="pages-main-box">{children}</Box>
      </Box>
    </Box>
  );
};

export default MainContent;
